<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="Id"
      ref="list"
      unit="存货档案"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="getDataFunc"
      :query-params="params"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/mould").default,
      params: {
        JobName: "",
        Status: null,
      },
    };
  },
  methods: {
    getDataFunc(params = {}) {
      return new Promise((resolve) => {
          resolve({ Count: 3, Data: [
            { Id: 1, chlx: 0, chbm: "3001A", chmc: "3001A", ggxh: "001", chfl: "粉盒", url: "", Status: 1 },
            { Id: 2, chlx: 1, chbm: "3001A-C", chmc: "3001A盖", ggxh: "001", chfl: "粉盒", url: "", Status: 1 },
            { Id: 3, chlx: 1, chbm: "3001A-M", chmc: "3001A中格", ggxh: "002", chfl: "粉盒", url: "", Status: 1 },
          ]});
      });
    },
    onExport() {
      // var loading = this.$loading({
      //   lock: true,
      //   text: "正在导出...",
      //   spinner: "el-icon-loading",
      //   customClass: "my_loading",
      //   background: "rgba(0, 0, 0, 0.3)",
      // });
      // this.api.export(this.params).then(() => {
      //   loading.close();
      // });
    },
    delRange(ids) {
      // this.api.delete({ ids }).then((res) => {
      //   if (res.Code == 0) {
      //     this.$message.success("删除成功");
      //     this.reload();
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
    },
  },
};
</script>